import { render, staticRenderFns } from "./OverviewAlerts.vue?vue&type=template&id=0c086964&scoped=true&"
import script from "./OverviewAlerts.vue?vue&type=script&lang=js&"
export * from "./OverviewAlerts.vue?vue&type=script&lang=js&"
import style0 from "./OverviewAlerts.vue?vue&type=style&index=0&id=0c086964&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c086964",
  null
  
)

export default component.exports